import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-group";

export const pagingPatientGroup = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getPatientGroupById = (medicalEquipmentId) =>
  axios.get(API_PATH + "/get-by-id/" + medicalEquipmentId);

export const saveOrUpdatePatientGroup = (medicalEquipment) =>
  axios.post(API_PATH + "/save", medicalEquipment);

export const deletePatientGroup = (medicalEquipmentId) =>
  axios.delete(API_PATH + "/mark-delete/" + medicalEquipmentId);

export const syncPatientGroup = (obj) =>
  axios.post(API_PATH + "/sync-patient-group", obj);
